import { DescriptionFieldProps, RJSFSchema, StrictRJSFSchema } from '@rjsf/utils';

import { Paragraph } from 'design-system/components/Text';

/** The `DescriptionField` is the template to use to render the description of a field
 *
 * @param props - The `DescriptionFieldProps` for this component
 */
export function DescriptionFieldTemplate<T = any, S extends StrictRJSFSchema = RJSFSchema, F = any>(
  /* @ts-expect-error [strict-migration] The following line is not strict; please fix! */
  props: DescriptionFieldProps<T, S, F>,
) {
  const { id, description } = props;
  if (!description) {
    return null;
  }
  return <Paragraph id={id}>{description}</Paragraph>;
}
